import {createFileRoute, Outlet} from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/organizations/$orgId')({
    component: OrganizationLayout,
})

function OrganizationLayout() {
    return <Outlet />
}
